import React from 'react';
import Figures from '../features/Dashboard/components/figures';
import { useSubscriptionsStore } from '../features/Subscriptions/store/subscriptions';
import { useUserStore } from '../features/Users/store/userStore';
import { usePackagesStore } from '../features/Packages/store/packagesStore';
import AnalyticsHeader from '../features/Analytics/components/AnalyticsHeader';
import PaymentsChart from '../features/Analytics/components/charts/PaymentsChart';
import SubscribersChart from '../features/Analytics/components/charts/SubscribersChart';
import PackagePerformance from '../features/Analytics/components/packagePerformance';
import GatewayDistribution from '../features/Analytics/components/gatewayDistribution';

const AnalyticsContent: React.FC = () => {
    const { stats } = useSubscriptionsStore();
    const { users, newUsers } = useUserStore();
    const { packages } = usePackagesStore();
    return (
        <div className='w-full py-6'>
            <AnalyticsHeader />
            <Figures
                users={users.length}
                newUsers={newUsers.length}
                packages={packages.length}
                revenue={stats?.totalRevenue || 0}
                activeSubscribers={stats?.activeSubscribers || 0}
                loadingUsers={false}
                loadingNewUsers={false}
                loadingPackages={false}
                loadingRevenue={false}
                loadingSubscribers={false}
            />
            <div className='w-full flex items-center justify-center gap-x-4'>
                <div className='w-1/2'>
                    <PaymentsChart />
                </div>
                <div className='w-1/2'>
                    <SubscribersChart />
                </div>
            </div>
            <div className='w-full flex items-start justify-center gap-x-4 my-3'>
                <div className='w-1/2'>
                    <PackagePerformance />
                </div>
                <div className='w-1/2'>
                    <GatewayDistribution />
                </div>
            </div>
        </div>
    );
};

export default AnalyticsContent;